import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { CorePopupComponent } from '../../../ui-components/core-popup/core-popup.component';
import { TableLazyLoadEvent } from 'primeng/table';
import {
  Option,
  OptionGroup,
} from '../../../ui-components/core-dropdown/core-dropdown.component';
import {
  IServicePriceItems,
  ServicesService,
} from '../../services/services/services/services.service';
import { catchError, forkJoin, of } from 'rxjs';
import { ServiceGroupsService } from '../../services/services/service-groups/service-groups.service';
import { ServiceSubGroupsService } from '../../services/services/service-subgroups/service-subgroups.service';
import { ServiceParentGroupsService } from '../../services/services/service-parent-groups/service-parent-groups.service';
import { ParameterService } from '../../services/parameter/parameter.service';
import { AppMessageService } from '../../services/app-message/app-message.service';

export interface IServicePricePopupResponse {
  services: IServicePriceItems[];
  totalPrice: number;
  numberOfService: number;
}
@Component({
  selector: 'app-service-price-popup',
  templateUrl: './service-price-popup.component.html',
  styleUrl: './service-price-popup.component.scss',
})
export class ServicePricePopupComponent implements OnInit {
  @ViewChild('popup') popup: CorePopupComponent;
  @Output() saveOn = new EventEmitter<IServicePricePopupResponse>();
  @Input() priceTypeId: number | null = null;
  @Input() priceTypeLabel: string | null = null;
  @Input() date: Date | null = null;

  parentGroups: Option[] = [];
  servicePanels: Option[] = [];
  subgroups: OptionGroup[] = [];
  allServices: IServicePriceItems[] = [];
  allServicesSource: any[] = [];
  filteredSubgroups: OptionGroup[] = [];
  selectedServices: IServicePriceItems[] = [];
  filter: any = {
    serviceSubgroupId: null,
    serviceParentGroupId: null,
    serviceGroupId: null,
    search: '',
    servicePanelId: null,
  };

  loading: boolean = false;
  openPopup: boolean = false;
  total: number = 0;
  numberOfService: number = 0;

  constructor(
    private readonly servicesService: ServicesService,
    private readonly serviceGroup: ServiceGroupsService,
    private readonly serviceSubgroup: ServiceSubGroupsService,
    private readonly serviceParentgroup: ServiceParentGroupsService,
    private readonly parameterService: ParameterService,
    private readonly messageService: AppMessageService
  ) {}
  ngOnInit() {
    forkJoin({
      parentGroups: this.serviceParentgroup
        .getAll({ isActive: true })
        .pipe(catchError(() => of([]))),
      subgroups: this.serviceSubgroup
        .getAll({ isActive: true })
        .pipe(catchError(() => of([]))),
      groups: this.serviceGroup
        .getAll({ isActive: true })
        .pipe(catchError(() => of([]))),
      panels: this.parameterService
        .getValues('data-group', 'service-panels')
        .pipe(catchError(() => of(null))),
    }).subscribe((results) => {
      this.parentGroups = results?.parentGroups?.map((pG) => ({
        label: pG?.name,
        value: pG?.id,
        disabled: !pG?.isActive,
      }));

      const subG = results?.subgroups?.map((sG) => ({
        label: sG.name,
        value: sG?.id,
        parentGroup: sG.serviceParentGroup?.id,
        disabled: !sG?.isActive,
      }));

      this.subgroups = subG?.map((sG) => {
        return {
          ...sG,
          items: results.groups
            ?.filter((g) => g.serviceSubgroup?.id === sG.value)
            .map((g) => ({
              label: g.name,
              value: g?.id,
              disabled: !g?.isActive,
            })),
        };
      });
      this.servicePanels =
        results?.panels?.datas?.values?.map((data: any) => {
          return {
            label: data?.valueObject?.name?.value,
            value: data?.valueObject?.id?.value,
            disabled: !data?.valueObject?.status?.value,
          };
        }) ?? [];
    });
  }

  async getList(event: TableLazyLoadEvent,loading:boolean=true ) {
    if (loading) {
      this.loading = true;
    }
    this.servicesService
      .getServicesWithPrice(
        this.filter,
        this.priceTypeId,
        this.date
      )
      .subscribe({
        next: (res) => {
          this.allServices = res?.items?.length > 0 ? [...res.items] : [];
          this.allServicesSource = res.items ?? [];
          this.loading = false;
        },
        error: (error) => {
          this.loading = false;
        },
      });
  }

  applySearchFilter() {
    const search = this.filter.search?.toLowerCase().trim();

    if (!search) {
      this.allServices = [...this.allServicesSource];
      return;
    }

    this.allServices = this.allServicesSource.filter(service =>
      service?.serviceName?.toLowerCase().includes(search) ||
      service?.serviceCode?.toLowerCase().includes(search)
    );
    this.getList({},false)
  }


  filterParentGroupChange(event: any) {
    const parentIds = event?.value;
    this.filteredSubgroups = this.subgroups.filter(
      (sg: any) => parentIds === sg?.parentGroup
    );
  }

  subGroupChange() {
    const subGroup = this.filteredSubgroups.find((group) =>
      group.items.some((item) => item.value === this.filter?.serviceGroupId)
    );
    this.filter.serviceSubgroupId = subGroup?.value ?? null;
  }

  onSelectAllChange(event: any) {
    if (event) {
      this.selectedServices = this.allServices.filter(service =>
        !this.isDisabled(service)
      );
    } else {
      this.selectedServices = [];
    }
  }

   isDisabled(service: any): boolean {
    return (
      (service?.gatePrice?.originalPrice == null) &&
      (service?.memberPrice?.originalPrice == null)
    );
  }

  rowSelect() {
    //eğer döviz döviz dönüşü yapılamamış ise onları seçtirtme.
    const nullPrice = this.selectedServices.filter((service) => {
      let type: 'memberPrice' | 'gatePrice' | null = null;

      if (service?.memberPrice?.originalPrice != null) {
        type = 'memberPrice';
      } else if (service?.gatePrice?.originalPrice != null) {
        type = 'gatePrice';
      }
      if (
        type === 'memberPrice' &&
        (service.memberPrice?.price === null ||
          service.memberPrice?.price === undefined)
      ) {
        return true;
      } else if (
        type === 'gatePrice' &&
        (service.gatePrice?.price === null ||
          service.gatePrice?.price === undefined)
      ) {
        return true;
      }
      if(type===null){
        return true;
      }
      return false;
    });

    if (nullPrice.length > 0) {
      setTimeout(() => {
        this.selectedServices = this.selectedServices.filter((s) =>
          nullPrice.some((n) => n.serviceId !== s.serviceId)
        );
      }, 0);
      this.messageService.errorToast(
        'Döviz Kuru bulunamaı',
        'Döviz dönüşümü yapılamadığı için bu hizmet seçilemez.'
      );
      return;
    }
    if (
      nullPrice.length === 0 &&
      this.selectedServices?.length
    ) {
      this.total = 0;

      for (const service of this.selectedServices) {
        service.quantity = 1;

        // priceType belirle
        if (service?.memberPrice?.originalPrice != null) {
          service.priceType = 'memberPrice';
        } else if (service?.gatePrice?.originalPrice != null) {
          service.priceType = 'gatePrice';
        } else {
          service.priceType = null;
        }

        // unitPrice belirle
        if (service.priceType === 'memberPrice') {
          service.unitPrice = service?.memberPrice?.price ?? null;
        } else if (service.priceType === 'gatePrice') {
          service.unitPrice = service?.gatePrice?.price ?? null;
        } else {
          service.unitPrice = null;
        }

        // total hesapla (quantity sabit 1 olduğundan direkt unitPrice)
        service.total = service.unitPrice ?? 0;

        // genel toplam güncelle
        this.total += service.total;
      }

      this.calculateNumberOfService();
    }
  }

  onQuantityChange(event: any, service: IServicePriceItems) {
    const beforePrice = service?.total ?? 0;
    let basePrice: number | null = null;

    if (service.priceType === 'memberPrice') {
      basePrice = service?.memberPrice?.price ?? null;
    } else if (service.priceType === 'gatePrice') {
      basePrice = service?.gatePrice?.price ?? null;
    }

    if (service.quantity === 0 || service.quantity === null || service.quantity === undefined) {
      service.quantity = 1;
    }
    service.total = basePrice ? service.quantity * basePrice : 0;
    const serviceTotal = service?.total ?? 0;
    this.total += serviceTotal - beforePrice;
    this.calculateNumberOfService();
  }

  calculateNumberOfService() {
    this.numberOfService = 0;
    for(const s of this.selectedServices){

      this.numberOfService += s?.quantity ?? 0;
    }
  }

  resetParams() {
    this.allServices = [];
    this.selectedServices = [];
    this.filter = {
      serviceSubgroupId: null,
      serviceParentGroupId: null,
      search: null,
      serviceGroupId: null,
      servicePanelId: null,
    };
    this.openPopup = false;
    this.total = 0;
    this.numberOfService = 0;
  }

  deleteItem(service: IServicePriceItems) {
    this.selectedServices = this.selectedServices.filter(
      (s) => s.serviceId !== service.serviceId
    );
    this.rowSelect();
  }
  clearFilters() {
    this.filter = {
      serviceSubgroupId: null,
      serviceParentGroupId: null,
      search: null,
      serviceGroupId: null,
      servicePanelId: null,
    };
    this.getList({});
  }
  onPopupClosed() {
    this.resetParams();
  }
  save() {
    const services = this.selectedServices.filter((service) => {
      if (
        (service?.gatePrice?.price === null ||
          service?.gatePrice?.price === undefined) &&
        (service?.memberPrice?.price === null ||
          service?.memberPrice?.price === undefined)
      ) {
        return false;
      }
      return true;
    });
    let numberOfService = 0;
    for(const s of services){
      numberOfService += s?.quantity ?? 0;

    }
    this.saveOn.emit({
      services: services,
      totalPrice: this.total,
      numberOfService: numberOfService,
    });
    this.popup.closeDialog();
  }

  initilize() {
    this.popup.openDialog();
    this.openPopup = true;
  }
}
